import { Component, HostListener } from '@angular/core';
import { LocalStoreService } from "../../../services";
import {Compbaser} from "../../../components/compbaser";

@Component({
    selector: 'app-editor-background',
    templateUrl: './editor-background.component.html',
    styleUrls: ['./editor-background.component.scss'] // Corrected "styleUrl" to "styleUrls"
})
export class EditorBackgroundComponent extends Compbaser {
    theme;
    bgSelection = '0';
    dropdownOpen = false;

    constructor(protected localStoreService: LocalStoreService) {
        super();
        this.bgSelection = this.localStoreService.getStorageValConfig('sceneCheckeredBackground') || '0';

        this.cod(
            this.localStoreService.theme.subscribe((val) => {
                this.theme = this.localStoreService.getStorageValConfig('theme');
            })
        );
    }

    onActiveBgSelection(i_value: string) {
        this.bgSelection = i_value;
        this.localStoreService.setStorageValConfig('sceneCheckeredBackground', i_value);
        this.dropdownOpen = false; // Close the dropdown after selection
    }

    toggleDropdown(): void {
        this.dropdownOpen = !this.dropdownOpen;
    }

    getSelectedBgIcon(): string {
        const icons = {
            '0': 'assets/images/black.png',
            '1': 'assets/images/dots.png',
            '2': 'assets/images/checkers.png',
            '3': 'assets/images/rows.png',
        };
        return icons[this.bgSelection] || 'assets/images/default.png';
    }

    @HostListener('document:click', ['$event'])
    closeDropdownOnOutsideClick(event: Event): void {
        const target = event.target as HTMLElement;
        if (!target.closest('.dropdown-container')) {
            this.dropdownOpen = false;
        }
    }
}
